import NotificationManager from 'react-notifications/lib/NotificationManager';

import userStatisticActionTypes from '../actionTypes/userStatisticActionTypes';
import { getUserStatisticApi, getAboutUsersApi, setAboutUsersApi } from '../../api/apiUrls/userStatistic';

const getStatisticStart = () => ({
  type: userStatisticActionTypes.GET_STATISTIC_START,
});
const getStatisticSuccess = (payload) => ({
  type: userStatisticActionTypes.GET_STATISTIC_SUCCESS,
  payload,
});
const getStatisticFail = () => ({
  type: userStatisticActionTypes.GET_STATISTIC_FAILURE,
});

const getUserStatistic = (token) => (dispatch) => {
  dispatch(getStatisticStart());

  return getUserStatisticApi(token)
    .then((response) => {
      if (response.data.success) {
        dispatch(getStatisticSuccess(response.data.data));
      }
    })
    .catch(() => {
      dispatch(getStatisticFail());
    });
};

const getAboutStart = () => ({
  type: userStatisticActionTypes.GET_ABOUT_START,
});
const getAboutSuccess = (payload) => ({
  type: userStatisticActionTypes.GET_ABOUT_SUCCESS,
  payload,
});
const getAboutFail = () => ({
  type: userStatisticActionTypes.GET_ABOUT_FAILURE,
});

const getAboutUser = (token, name = null) => (dispatch) => {
  dispatch(getAboutStart());

  return getAboutUsersApi(token, name)
    .then((response) => {
      if (response.data.success) {
        dispatch(getAboutSuccess(response.data.data));
      }
    })
    .catch(() => {
      dispatch(getAboutFail());
    });
};

const setAboutStart = () => ({
  type: userStatisticActionTypes.SET_ABOUT_START,
});
const setAboutSuccess = (payload) => ({
  type: userStatisticActionTypes.SET_ABOUT_SUCCESS,
  payload,
});
const setAboutFail = () => ({
  type: userStatisticActionTypes.SET_ABOUT_FAILURE,
});

const setAboutUser = (token, data) => (dispatch) => {
  dispatch(setAboutStart());

  return setAboutUsersApi(token, data)
    .then((response) => {
      if (response.data.success) {
        dispatch(setAboutSuccess(response));
        NotificationManager.success('Info is changed');
      }
    })
    .catch(() => {
      dispatch(setAboutFail());
    });
};

const userStatisticActions = {
  getUserStatistic,
  getAboutUser,
  setAboutUser,
};

export default userStatisticActions;
